const indexData = [
  { id: 1, name: '明星动态', count: '326篇', icon: 'ri-star-line', desc: '最新明星行程、活动、街拍与日常' },
  { id: 2, name: '网红黑料', count: '218篇', icon: 'ri-user-smile-line', desc: '头部网红争议事件与翻车合集' },
  { id: 3, name: '综艺揭秘', count: '187篇', icon: 'ri-tv-line', desc: '综艺节目幕后制作与现场爆料' },
  { id: 4, name: '影视八卦', count: '165篇', icon: 'ri-film-line', desc: '电影电视剧拍摄花絮与选角内幕' },
  { id: 5, name: '音乐争议', count: '142篇', icon: 'ri-music-line', desc: '音乐圈抄袭、假唱与版权纠纷' },
  { id: 6, name: '情感爆料', count: '98篇', icon: 'ri-heart-line', desc: '明星恋情婚变与情感纠葛追踪' },
  { id: 7, name: '独家深挖', count: '76篇', icon: 'ri-search-eye-line', desc: '编辑部资深记者独家调查报道' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            瓜料分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">七个频道，全方位覆盖吃瓜需求</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-start gap-4 p-5 bg-background-100 border border-background-200/60 rounded-lg cursor-pointer hover:border-primary-200/60 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-lg bg-primary-100 text-primary-500">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <span className="text-xs text-primary-500 font-medium mt-2 inline-block">
                  {item.count}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexData.slice(4, 7).map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-start gap-4 p-5 bg-background-100 border border-background-200/60 rounded-lg cursor-pointer hover:border-primary-200/60 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-lg bg-accent-100 text-accent-500">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <span className="text-xs text-accent-500 font-medium mt-2 inline-block">
                  {item.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}